var map = {
	"./account-primary.svg": "3884",
	"./account-white.svg": "3295",
	"./add-dark.svg": "bbd6",
	"./add-green.svg": "04c2",
	"./add-white.svg": "431c",
	"./admin-primary.svg": "c920",
	"./admin-white.svg": "070a",
	"./book-primary.svg": "8bf9",
	"./book-white.svg": "d56f",
	"./close-dark.svg": "2c95",
	"./close-green.svg": "99f4",
	"./close-red.svg": "8f40",
	"./close-warning.svg": "98a7",
	"./close-white.svg": "72e4",
	"./cog-primary.svg": "a00b",
	"./cog-white.svg": "5b4b",
	"./cube-primary.svg": "617e",
	"./cube-white.svg": "326c",
	"./dashboard-primary.svg": "47fe",
	"./dashboard-white.svg": "1520",
	"./delete-dark.svg": "aa22",
	"./delete-primary.svg": "2a7c",
	"./delete-red.svg": "9cdc",
	"./delete-white.svg": "744f",
	"./drawer.svg": "7ce6",
	"./edit-block-dark.svg": "39fe",
	"./edit-block-primary.svg": "5306",
	"./edit-dark.svg": "87cb",
	"./feather-primary.svg": "47f6",
	"./feather-white.svg": "4a62",
	"./files-primary.svg": "2329",
	"./files-white.svg": "7495",
	"./filter-dark.svg": "0fd5",
	"./find-primary.svg": "aa85",
	"./find-white.svg": "757a",
	"./info-dark.svg": "2c07",
	"./lock-primary.svg": "adf2",
	"./lock-white.svg": "c655",
	"./notification-error.svg": "cbb3",
	"./notification-info.svg": "a5c5",
	"./notification-success.svg": "2baa",
	"./notification-warning.svg": "42ee",
	"./payment-primary.svg": "af0e",
	"./payment-white.svg": "ba6a",
	"./price-primary.svg": "fed9",
	"./price-white.svg": "ef14",
	"./refresh-dark.svg": "51d1",
	"./refresh-white.svg": "d09f",
	"./repeat-dark.svg": "a406",
	"./row-right-dark.svg": "c954",
	"./row-right-white.svg": "0cf0",
	"./server-primary.svg": "1c46",
	"./server-white.svg": "6bfa",
	"./slash-dark.svg": "891a",
	"./slash-primary.svg": "a852",
	"./tablet-dark.svg": "d3f2",
	"./timer-primary.svg": "5bdd",
	"./timer-white.svg": "d4df",
	"./trial-primary.svg": "b603",
	"./trial-white.svg": "44a2",
	"./user-primary.svg": "bdc9",
	"./user-white.svg": "1df7",
	"./users-primary.svg": "45de",
	"./users-white.svg": "13de"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";